// @generated by protoc-gen-es v1.10.1 with parameter "target=ts,import_extension=none"
// @generated from file mono/datagateway/v1/notification_preferences.proto (package mono.datagateway.v1, syntax proto3)
/* eslint-disable */ // @ts-nocheck
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { Message, proto3 } from "@bufbuild/protobuf";
/**
 * NotificationPreferenceSubject is whose preferences these are: "TENANT"
 * (the company default, id = tenant id), "USER" (a platform user id; the
 * canonical key for anyone with an account, including a linked contact), or
 * "CONTACT" (a delivery contact without an account).
 *
 * @generated from message mono.datagateway.v1.NotificationPreferenceSubject
 */ export class NotificationPreferenceSubject extends Message {
    static fromBinary(bytes, options) {
        return new NotificationPreferenceSubject().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new NotificationPreferenceSubject().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new NotificationPreferenceSubject().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(NotificationPreferenceSubject, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string type = 1;
   */ _define_property(this, "type", ""), /**
   * @generated from field: string id = 2;
   */ _define_property(this, "id", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(NotificationPreferenceSubject, "runtime", proto3);
_define_property(NotificationPreferenceSubject, "typeName", "mono.datagateway.v1.NotificationPreferenceSubject");
_define_property(NotificationPreferenceSubject, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.NotificationChannelPreference
 */ export class NotificationChannelPreference extends Message {
    static fromBinary(bytes, options) {
        return new NotificationChannelPreference().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new NotificationChannelPreference().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new NotificationChannelPreference().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(NotificationChannelPreference, a, b);
    }
    constructor(data){
        super(), /**
   * False when the kind does not ride this channel; mode is then empty.
   *
   * @generated from field: bool available = 1;
   */ _define_property(this, "available", false), /**
   * The effective mode for this subject.
   *
   * @generated from field: string mode = 2;
   */ _define_property(this, "mode", ""), /**
   * Which layer mode came from: "PERSONAL", "COMPANY" or "BUILT_IN". For a
   * company subject, its own rows report "COMPANY".
   *
   * @generated from field: string source = 3;
   */ _define_property(this, "source", ""), /**
   * What resetting this subject's choice falls back to: the company
   * default (or built-in) for a person, the built-in default for a company.
   *
   * @generated from field: string default_mode = 4;
   */ _define_property(this, "defaultMode", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(NotificationChannelPreference, "runtime", proto3);
_define_property(NotificationChannelPreference, "typeName", "mono.datagateway.v1.NotificationChannelPreference");
_define_property(NotificationChannelPreference, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "available",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 2,
            name: "mode",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "source",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "default_mode",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.NotificationKindPreference
 */ export class NotificationKindPreference extends Message {
    static fromBinary(bytes, options) {
        return new NotificationKindPreference().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new NotificationKindPreference().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new NotificationKindPreference().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(NotificationKindPreference, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string kind = 1;
   */ _define_property(this, "kind", ""), /**
   * @generated from field: string label = 2;
   */ _define_property(this, "label", ""), /**
   * @generated from field: string description = 3;
   */ _define_property(this, "description", ""), /**
   * @generated from field: mono.datagateway.v1.NotificationChannelPreference in_app = 4;
   */ _define_property(this, "inApp", void 0), /**
   * @generated from field: mono.datagateway.v1.NotificationChannelPreference email = 5;
   */ _define_property(this, "email", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(NotificationKindPreference, "runtime", proto3);
_define_property(NotificationKindPreference, "typeName", "mono.datagateway.v1.NotificationKindPreference");
_define_property(NotificationKindPreference, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "description",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "in_app",
            kind: "message",
            T: NotificationChannelPreference
        },
        {
            no: 5,
            name: "email",
            kind: "message",
            T: NotificationChannelPreference
        }
    ]));
/**
 * NotificationPreferenceChange sets one kind's mode on one channel. An empty
 * mode resets it to the default.
 *
 * @generated from message mono.datagateway.v1.NotificationPreferenceChange
 */ export class NotificationPreferenceChange extends Message {
    static fromBinary(bytes, options) {
        return new NotificationPreferenceChange().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new NotificationPreferenceChange().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new NotificationPreferenceChange().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(NotificationPreferenceChange, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string kind = 1;
   */ _define_property(this, "kind", ""), /**
   * @generated from field: string channel = 2;
   */ _define_property(this, "channel", ""), /**
   * @generated from field: string mode = 3;
   */ _define_property(this, "mode", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(NotificationPreferenceChange, "runtime", proto3);
_define_property(NotificationPreferenceChange, "typeName", "mono.datagateway.v1.NotificationPreferenceChange");
_define_property(NotificationPreferenceChange, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "channel",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "mode",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
